module.exports = __webpack_public_path__ + "static/media/Amelia_Island_FL_History_Museum_Timucuan_Indian_Village_diorama.d08fbc09.webp";